import React from 'react'

import KmlSvg from '@images/area/download_kml.svg'

const KmlIcon = React.forwardRef(({ style, ...props }, ref) => (
  <img
    ref={ref}
    src={KmlSvg}
    alt="KML"
    {...props}
    style={{ width: 24, height: 24, verticalAlign: 'middle', ...style }}
  />
))

export default KmlIcon
